var map = {
	"./box.svg": "../../packages/micro-components/BasisIcon/icons/box.svg?inline",
	"./close.svg": "../../packages/micro-components/BasisIcon/icons/close.svg?inline",
	"./empty-nomsg.svg": "../../packages/micro-components/BasisIcon/icons/empty-nomsg.svg?inline",
	"./empty-norecord.svg": "../../packages/micro-components/BasisIcon/icons/empty-norecord.svg?inline",
	"./empty.svg": "../../packages/micro-components/BasisIcon/icons/empty.svg?inline",
	"./upload.svg": "../../packages/micro-components/BasisIcon/icons/upload.svg?inline",
	"./wszy-logo-slogan.svg": "../../packages/micro-components/BasisIcon/icons/wszy-logo-slogan.svg?inline",
	"./wszy-logo.svg": "../../packages/micro-components/BasisIcon/icons/wszy-logo.svg?inline",
	"./wszy-slogan.svg": "../../packages/micro-components/BasisIcon/icons/wszy-slogan.svg?inline",
	"./zljm-logo.svg": "../../packages/micro-components/BasisIcon/icons/zljm-logo.svg?inline"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/micro-components/BasisIcon/icons sync recursive ^\\.\\/.*\\.svg$";